import React from "react";
import {
    Box,
    Checkbox,
    FormControlLabel,
    Typography,
    styled,
} from "@mui/material";

const ItemContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(1.5),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "7px",
    backgroundColor: theme.palette.background.paper,
    "&:hover": {
        backgroundColor: theme.palette.grey[50],
    },
}));

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
    padding: 0,
    marginRight: theme.spacing(1),
    "& .MuiSvgIcon-root": {
        fontSize: "1rem",
    },
    "&.Mui-checked": {
        color: theme.palette.primary.main,
    },
    "&:hover": {
        backgroundColor: "transparent",
    },
}));

export interface CheckboxItemProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    title: string;
    description?: string;
    disabled?: boolean;
}

export const CheckboxItem: React.FC<CheckboxItemProps> = ({
    checked,
    onChange,
    title,
    description,
    disabled = false,
}) => {
    return (
        <ItemContainer>
            <FormControlLabel
                control={
                    <StyledCheckbox
                        checked={checked}
                        onChange={(e) => onChange(e.target.checked)}
                        size="small"
                        disabled={disabled}
                    />
                }
                label={
                    <Box>
                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: "0.8rem",
                                fontWeight: description ? 600 : 400,
                                lineHeight: 1.2,
                            }}
                        >
                            {title}
                        </Typography>
                        {description && (
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{
                                    fontSize: "0.6875rem",
                                    lineHeight: 1.2,
                                    display: "block",
                                }}
                            >
                                {description}
                            </Typography>
                        )}
                    </Box>
                }
                sx={{ margin: 0, width: "100%" }}
            />
        </ItemContainer>
    );
};
